import { t } from '@lingui/macro'

export function validatePath(newName: string) {
  if (!newName) {
    return t`Name is required!`
  }
  if (/(\/|\\)/.test(newName)) {
    return t`You can not use '/' in the folder name`
  }
}
